/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Card, DateRange } from 'shared/theme/elements';
import styled from 'styled-components';

export const ListWrapper = styled.div`
  height: 100%;
  ${Card} {
    height: 100%;
  }
`;
export const TopContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const LeftContainer = styled.div``;
export const RightContainer = styled.div``;
export const RightContainerDate = styled(Card)`
  position: relative;
  float: right !important;
  margin-right: -18px;
  border: none;
  margin-bottom: 1%;
  margin-top: -6%;
  background-color: rgba(0, 0, 0, 0);
  padding: 0px !important;
  @media only screen and (max-width: 1450px) {
    margin-top: -8%;
  }
`;

export const RightContainerNonDisplay = styled(Card)`
  display: none;
`;
export const TableContainer = styled.div`
  .table-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
    margin-top: 2rem;
  }
`;

export const PublisherNameLink = styled.span`
  cursor: pointer;

  &:hover {
    color: #40a9ff;
    transition: all 0.2s;
  }
`;
